import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Tools|Accredible|Search Form|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.ShareAccredibleBadging,
	portal: 'SP',
};

type LocNameStart = 'SPToolsAccredibleSearchForm';
export type SPToolsAccredibleSearchFormLocNames =
	| `${LocNameStart}LabelSearch`
	| `${LocNameStart}LabelCmcId`
	| `${LocNameStart}LabelExternalId`
	| `${LocNameStart}LabelFor`
	| `${LocNameStart}ErrorSearchTypeRequired`
	| `${LocNameStart}ErrorSearchParamRequired`
	| `${LocNameStart}ErrorSearchParamPattern`
	| `${LocNameStart}ErrorMaxCmcId`
	| `${LocNameStart}ButtonSearchToDelete`
	| `${LocNameStart}ButtonSearch`;

export const spToolsAccredibleSearchFormLocs: LocDefs<SPToolsAccredibleSearchFormLocNames> = {
	SPToolsAccredibleSearchFormLabelSearch: {
		defaultValue: 'Search',
		description: 'Label for: Search.',
		displayPath: `${pathStart}Search`,
		displayType: 'Label',
		legacyName: 'Share.AccredibleBadging/Accredible.BadgeSearch.FieldLabel.Search',
		...sharedProperties,
	},
	SPToolsAccredibleSearchFormLabelCmcId: {
		defaultValue: 'CMC ID',
		description: 'Label for: CMC ID.',
		displayPath: `${pathStart}CMC ID`,
		displayType: 'Label',
		legacyName: 'Share.AccredibleBadging/Accredible.BadgeSearch.FieldLabel.CMCId',
		...sharedProperties,
	},
	SPToolsAccredibleSearchFormLabelExternalId: {
		defaultValue: 'Client ID',
		description: 'Label for: Client ID.',
		displayPath: `${pathStart}Client ID`,
		displayType: 'Label',
		legacyName: 'Share.AccredibleBadging/Accredible.BadgeSearch.FieldLabel.ExternalId',
		...sharedProperties,
	},
	SPToolsAccredibleSearchFormLabelFor: {
		defaultValue: 'For',
		description: 'Label for: For.',
		displayPath: `${pathStart}For`,
		displayType: 'Label',
		legacyName: 'Share.AccredibleBadging/Accredible.BadgeSearch.FieldLabel.For',
		...sharedProperties,
	},
	SPToolsAccredibleSearchFormErrorSearchTypeRequired: {
		defaultValue: 'Selection of a search type is required.',
		description: 'Error message for when a search type is required.',
		displayPath: `${pathStart}Search Type Required`,
		displayType: 'Error',
		legacyName: 'Share.AccredibleBadging/Accredible.BadgeSearch.FieldError.SearchTypeRequired',
		...sharedProperties,
	},
	SPToolsAccredibleSearchFormErrorSearchParamRequired: {
		defaultValue: 'A valid ID for search of the selected type is required.',
		description: 'Error message for when a search ID is required.',
		displayPath: `${pathStart}Search ID Required`,
		displayType: 'Error',
		legacyName: 'Share.AccredibleBadging/Accredible.BadgeSearch.FieldError.SearchParamRequired',
		...sharedProperties,
	},
	SPToolsAccredibleSearchFormErrorSearchParamPattern: {
		defaultValue: 'This is not a valid ID for the selected search type.',
		description: 'Error message for when a search ID is invalid.',
		displayPath: `${pathStart}Search ID Invalid`,
		displayType: 'Error',
		legacyName: 'Share.AccredibleBadging/Accredible.BadgeSearch.FieldError.SearchParamPattern',
		...sharedProperties,
	},
	SPToolsAccredibleSearchFormErrorMaxCmcId: {
		defaultValue: 'CMC ID must be positive number less than 2147483647.',
		description: 'Error message for when the CMC ID is too large.',
		displayPath: `${pathStart}CMC ID too large`,
		displayType: 'Error',
		legacyName: 'Share.AccredibleBadging/Accredible.BadgeSearch.FieldError.MaxCmcId',
		...sharedProperties,
	},
	SPToolsAccredibleSearchFormButtonSearchToDelete: {
		defaultValue: 'Search to delete',
		description: 'Search to delete button',
		displayPath: `${pathStart}Search to delete`,
		displayType: 'Button',
		legacyName: 'Share.AccredibleBadging/Accredible.BadgeSearch.Button.SearchToDelete',
		...sharedProperties,
	},
	SPToolsAccredibleSearchFormButtonSearch: {
		defaultValue: 'Search',
		description: 'Search button',
		displayPath: `${pathStart}Search`,
		displayType: 'Button',
		legacyName: 'Share.AccredibleBadging/Accredible.BadgeSearch.Button.Search',
		...sharedProperties,
	},
};

export type SPToolsAccredibleSearchFormLocType = LocMap<SPToolsAccredibleSearchFormLocNames>;
